import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../core/services/user.service';
import { take } from 'rxjs/operators';
import { BaseComponent } from '../../area-privada/components/base/base.component';

@Component({
  selector: 'dum-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.scss']
})
export class RestorePasswordComponent extends BaseComponent implements OnInit {

  email: string;
  password: string;
  repeatPassword: string;
  codRestore: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private route: Router) {
    super();
    this.activatedRoute.paramMap.subscribe((params) => {
      const cod = params.get('cod');
      if (cod != null && cod !== undefined) {
        this.codRestore = cod;
      }
    })
   }

  ngOnInit(): void {
  }

  restore() {
    this.userService.updatePassword(this.email, this.codRestore, this.password)
    .pipe(take(1))
    .subscribe((result) => {
      this.dumToast.add({ severity: 'success', summary: 'Restaurar contraseña', detail: result.message });
      this.route.navigate(['/']);
    },(error) => {
      this.dumToast.add({ severity: 'error', summary: 'Restaurar contraseña', detail: error.error.message });
    });
  }
}
